import { FlexibleBlockTemplate } from '@nx-frontend/shared/types';
import { FlexibleBlockView } from './templates/common';
import { getInfoCardBlockViews } from './templates/template-info-card';
import { getTimelineBlockViews } from './templates/template-timeline';

export const getFlexibleBlockViews = ({ type, view }: FlexibleBlockTemplate): FlexibleBlockView[] => {
  const views: FlexibleBlockView[] =
    type === 'timeline'
      ? getTimelineBlockViews()
      : type === 'info-card'
      ? getInfoCardBlockViews()
      : [
          {
            key: view,
            template: { type, view },
            title: 'Custom view',
            image: '/assets/img/blocks/timeline/view-horizontal.png',
          },
        ];

  return views;
};
